// Assets & Icons
import { UserIcon as UsersIcon } from 'react-native-heroicons/solid';
import { theme } from '@breakroom-nx/assets';

// Components
import { HStack, VStack, Spacer, Text, View, Pressable } from 'native-base';
import { ChatBubble, UserAvatar } from '../../';

// Classes & Types
import { Room } from '@breakroom-nx/classes';
import { timeFrom } from '@breakroom-nx/helpers';
import { useGetMembersForRoomQuery } from '@breakroom-nx/redux';

// Redux
import {
  useAppDispatch,
  selectRoom,
  toggleChatRoomPanel,
} from '@breakroom-nx/redux';
import { useEffect } from 'react';

export interface ChatListCellProps {
  room: Room;
}

export function ChatListCell({ room }: ChatListCellProps) {
  const dispatch = useAppDispatch();
  const unreadMessage =
    room.lastMessage && room.lastRead
      ? new Date(room.lastMessage.createdAt) > new Date(room.lastRead)
      : true;

  // ! MIGHT NEED TO REMOVE THIS AND MOVE MEMBER FETCHING LOGIC ELSEWHERE
  const { data: members, isLoading: isLoadingMembers } =
    useGetMembersForRoomQuery(room);

  useEffect(() => {
    // console.log(
    //   `Room: ${room.title} Last Message Created At: ${
    //     room.lastMessage?.createdAt
    //   } | Last Read: ${room.lastRead} | ${
    //     new Date(room.lastMessage.createdAt) > new Date(room.lastRead)
    //   }`
    // );
  });

  const renderLastMessage = () => {
    if (room.lastMessage) {
      return (
        <HStack
          space={2}
          alignItems={'center'}
          justifyContent={'space-between'}
          width={'full'}
        >
          <HStack
            space={2}
            alignItems={'center'}
            justifyContent={'flex-start'}
            flex={1}
          >
            {!room.lastMessage.system && room.lastMessage.user._id && (
              <UserAvatar
                disabled
                noMargin
                noBorder
                size={6}
                uid={room.lastMessage.user._id as string}
              />
            )}
            <Text
              numberOfLines={1}
              color={unreadMessage ? 'primary.400' : 'surface.600'}
              isTruncated
              fontSize={13}
              fontWeight={600}
            >
              {room.lastMessage && room.lastMessage.text}
            </Text>
          </HStack>
          <View textAlign={'end'}>
            <Text fontSize={13} fontWeight={600} color={'surface.500'}>
              {timeFrom(new Date(room.lastMessage.createdAt))}
            </Text>
          </View>
        </HStack>
      );
    } else {
      return;
    }
  };

  return (
    <Pressable
      onPress={() => {
        // console.log(`DISPATCHING ROOM: ${room.title}`);
        dispatch(selectRoom(room));
        dispatch(toggleChatRoomPanel());
      }}
    >
      <HStack space={4} alignItems={'center'} mt={4}>
        <ChatBubble room={room} key={room.id} disabled={true} />
        <VStack space={3} flex={1}>
          <HStack space={3} alignItems={'center'}>
            <Text variant={'chatTitle'} fontSize={18}>
              {room.title}
            </Text>
            <Spacer />
            {members && (
              <HStack space={1} alignItems={'center'} justifyContent={'center'}>
                <UsersIcon size={14} color={theme.colors.surface[600]} />
                <Text fontSize={15} fontWeight={600} color={'surface.600'}>
                  {members.length.toLocaleString()}
                </Text>
              </HStack>
            )}
          </HStack>
          {renderLastMessage()}
        </VStack>
      </HStack>
    </Pressable>
  );
}

export default ChatListCell;
